// extracted by mini-css-extract-plugin
var _1 = "giftConfirmation_amount__Ehn-M";
var _2 = "giftConfirmation_code__xYFVO";
var _3 = "giftConfirmation_container__OkkRY";
var _4 = "giftConfirmation_details__YX87Z";
var _5 = "giftConfirmation_email__fZAuM";
var _6 = "giftConfirmation_giftCard__FHu3j";
var _7 = "giftConfirmation_header__ZCwt1";
var _8 = "giftConfirmation_message__V4SQj";
var _9 = "giftConfirmation_sendAnother__ZAmkU";
var _a = "giftConfirmation_text__quufo";
var _b = "giftConfirmation_wave__kpX6w";
export { _1 as "amount", _2 as "code", _3 as "container", _4 as "details", _5 as "email", _6 as "giftCard", _7 as "header", _8 as "message", _9 as "sendAnother", _a as "text", _b as "wave" }
